/**
 * Format function that shortens a number displayed and adds
 * K M B T for thousand, million, billion, trillion.
 *
 * @param y - number to format
 * @returns {*}
 */
export const formatKmbt = (y) => {
  if (isNaN(y)) {
    return '';
  }

  var abs_y = Math.abs(y);

  if (abs_y >= 1000000000000) {
    return (y / 1000000000000).toFixed(0) + "T"
  }
  else if (abs_y >= 1000000000) {
    return (y / 1000000000).toFixed(1) + "B"
  }
  else if (abs_y >= 100000000) {
    return (y / 1000000).toFixed(0) + "M"
  }
  else if (abs_y >= 10000000) {
    return (y / 1000000).toFixed(1) + "M"
  }
  else if (abs_y >= 1000000) {
    return (y / 1000000).toFixed(1) + "M"
  }
  else if (abs_y >= 100000) {
    return (y / 1000).toFixed(0) + "K"
  }
  else if (abs_y >= 10000) {
    return (y / 1000).toFixed(1) + "K"
  }
  else if (abs_y >= 1000) {
    return (y / 1000).toFixed(1) + "K"
  }
  else if (abs_y < 100 && abs_y >= 10) {
    return y.toFixed(1)
  }
  else if (abs_y < 10 && abs_y >= 2) {
    return y.toFixed(1)
  }
  else if (abs_y < 2 && abs_y >= 0.1) {
    return y.toFixed(2)
  }
  else if (abs_y < 0.1 && abs_y > 0) {
    return y.toFixed(2)
  }
  else if (abs_y === 0) {
    return 0
  }
  else {
    return y.toFixed(0)
  }
};

/**
 * Format function that shortens a number displayed and adds
 * K M B T for thousand, million, billion, trillion.
 *
 * @param y - number to format
 * @returns {*}
 */
export const formatKmbtPrecise = (y) => {
  if (isNaN(y)) {
    return '';
  }

  var abs_y = Math.abs(y);
  var isDecimal = y % 1 !== 0;

  if (abs_y >= 1000000000000) {
    return (y / 1000000000000).toFixed(0) + "T"
  }
  else if (abs_y >= 1000000000) {
    return (y / 1000000000).toFixed(0) + "B"
  }
  else if (abs_y >= 1000000) {
    return (y / 1000000).toFixed(0) + "M"
  }
  else if (abs_y >= 10000) {
    return (y / 1000).toFixed(0) + "K"
  }
  else if (abs_y >= 1000) {
    return (y / 1000).toFixed(1) + "K"
  }
  else if (abs_y < 100 && abs_y >= 10) {
    return y.toFixed(isDecimal ? 1 : 0)
  }
  else if (abs_y < 10 && abs_y >= 1) {
    return y.toFixed(isDecimal ? 2 : 0)
  }
  else if (abs_y < 1 && abs_y >= 0.1) {
    return y.toFixed(2)
  }
  else if (abs_y < 0.1 && abs_y > 0) {
    return y.toFixed(3)
  }
  else if (abs_y === 0) {
    return 0
  }
  else {
    return y.toFixed(0)
  }
};

/**
 * Formats a range array [min, max] into a kmbt string
 * If the lower or upper range is missing, uses < or +
 *
 * @param range
 * @returns {*}
 */
export const formatRange = (range) => {
  if (!range || !range.length || (!range[0] && !range[1])) {
    return '-';
  }
  else if (!range[0]) {
    return ' < ' + this.formatKmbt(range[1]);
  }
  else if (!range[1]) {
    return this.formatKmbt(range[1]) + ' + ';
  }
  else {
    return this.formatKmbt(range[0]) + ' - ' + this.formatKmbt(range[1]);
  }
}




// WEBPACK FOOTER //
// ./src/charts/utils/d3-mixins.js